var map = {
	"./Arrow": 8097,
	"./Arrow.js": 8097,
	"./ArrowDown": 4633,
	"./ArrowDown.js": 4633,
	"./ArrowRight": 5259,
	"./ArrowRight.js": 5259,
	"./Clock": 1038,
	"./Clock.js": 1038,
	"./Computer": 5863,
	"./Computer.js": 5863,
	"./Hexagon": 5712,
	"./Hexagon.js": 5712,
	"./LargeHexPattern": 4814,
	"./LargeHexPattern.js": 4814,
	"./Layers": 2932,
	"./Layers.js": 2932,
	"./Menu": 4085,
	"./Menu.js": 4085,
	"./Mobile": 3372,
	"./Mobile.js": 3372,
	"./MultipleUsers": 9924,
	"./MultipleUsers.js": 9924,
	"./Performance": 6598,
	"./Performance.js": 6598,
	"./PhoneIncrease": 8060,
	"./PhoneIncrease.js": 8060,
	"./SynapseLogo": 6620,
	"./SynapseLogo.js": 6620,
	"./TeamChat": 7397,
	"./TeamChat.js": 7397,
	"./TrendingUp": 1254,
	"./TrendingUp.js": 1254,
	"./TrustCheck": 3548,
	"./TrustCheck.js": 3548,
	"./icon": 4672,
	"./icon/": 4672,
	"./icon/icon.module.css": 6481,
	"./icon/index": 4672,
	"./icon/index.js": 4672
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2470;